// Event endpoints used by the dashboard.

import { api } from "./client.js";

/** @typedef {import("./types.js").MotionEvent} MotionEvent */
/** @typedef {import("./types.js").EventPage} EventPage */
/** @typedef {import("./types.js").SnapshotLink["kind"]} SnapshotKind */

/**
 * One page of events, newest first.
 * @param {{
 *   deviceId?: string | null,
 *   since?: Date | null,
 *   until?: Date | null,
 *   person?: boolean | null,
 *   cursor?: string | null,
 *   limit?: number,
 *   signal?: AbortSignal,
 * }} [options]
 * @returns {Promise<EventPage>}
 */
export function listEvents({ deviceId, since, until, person, cursor, limit = 30, signal } = {}) {
  return api.get("/events", {
    query: { device_id: deviceId, since, until, person, cursor, limit },
    signal,
  });
}

/**
 * Events per camera and hour (UTC), counted by the hub: for heatmaps and sparklines.
 * @param {{ deviceId?: string | null, since?: Date, until?: Date, signal?: AbortSignal }} [options]
 * @returns {Promise<import("./types.js").Activity>}
 */
export function getActivity({ deviceId, since, until, signal } = {}) {
  return api.get("/events/activity", { query: { device_id: deviceId, since, until }, signal });
}

/**
 * @param {string} id
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<MotionEvent>}
 */
export function getEvent(id, { signal } = {}) {
  return api.get(`/events/${encodeURIComponent(id)}`, { signal });
}

/**
 * The event's signed snapshot link of a kind, usable directly in an <img>.
 * @param {MotionEvent} event
 * @param {SnapshotKind} kind
 */
export function snapshotUrl(event, kind) {
  return event.snapshots.find((snapshot) => snapshot.kind === kind)?.url ?? null;
}
